<template>
  <v-navigation-drawer
    :model-value="props.drawerOpen"
  @update:modelValue="emit('update:drawerOpen', $event)"
  :temporary="props.isMobile"
  :permanent="!props.isMobile"
  :width="!props.isMobile && props.collapsed ? 100 : 265"
  app
  floating
  class="sidebar"
  >
    <!-- Logo -->
    <div class="logo-container">
      <img
        src="../assets/logo.png"
        class="logo-img"
        :style="{ width: collapsed ? '40px' : '12em' }"
        alt="Orchard Logo"
      />
    </div>

    <!-- GENERAL -->
    <v-list nav density="compact" class="sidebar-list">
      <v-list-subheader v-if="!collapsed" class="section-title">GENERAL</v-list-subheader>

      <v-list-item
        v-for="item in generalLinks"
        :key="item.title"
        :to="item.to"
        router
        link
        class="sidebar-item"
        active-class="router-link-active"
      >
        <template #prepend>
          <v-icon :icon="item.icon" class="sidebar-icon" />
        </template>

        <v-list-item-title v-if="!collapsed" class="sidebar-text">
          {{ item.title }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
   
  </v-navigation-drawer>
</template>

<script setup>
//import { watch, onMounted, onUnmounted } from 'vue'

const props = defineProps({
  collapsed: { type: Boolean, default: false },
  drawerOpen: { type: Boolean, default: false },
  isMobile: { type: Boolean, default: false },
})

const emit = defineEmits(["update:drawerOpen"])


const generalLinks = [
  { title: "Dashboard", to: "/dashboard", icon: "mdi-monitor-dashboard" },
  { title: "Invest", to: "/investments", icon: "mdi-finance" },
  { title: "Opportunities", to: "/opportunities", icon: "mdi-medal-outline" },
  { title: "Portfolio", to: "/portfolio", icon: "mdi-briefcase-plus-outline" },
  { title: "Transactions", to: "/transactions", icon: "mdi-swap-horizontal" },
  { title: "Referral", to: "/referral", icon: "mdi-podium-gold" },
]
</script>

<style scoped>
/* Sidebar base */
.sidebar {
  /* background: #ffffff; */
  border-right: 1px solid #eee;
  /* font-family: "Roboto", sans-serif; */
  transition: width 0.3s ease;
  background-color: #f3f4f6;
  padding: 12px; /* space around inner drawer */
  height: 100vh;
  display: flex;
  align-items: flex-start;
}

/* Logo */
.logo-container {
  display: flex;
  justify-content: center;
  padding: 16px 10px;
}

.logo-img {
  transition: width 0.3s ease;
}

/* FORCE list items to align left */
.sidebar-list {
  text-align: left;
}

/* Section titles */
.section-title {
  font-size: 12px;
  color: #9aa0a6;
  text-transform: uppercase;
  margin: 1px 0 5px;
  padding-left: 18px;
  justify-content: flex-start !important;
}

/* List item spacing */
.sidebar-item {
  padding-left: 18px !important;
  padding-right: 16px !important;
  min-height: 44px;
  font-size: 16px;
}

/* Force content to the left */
.sidebar-item .v-list-item__content {
  justify-content: flex-start !important;
  text-align: left !important;
}

/* Tighten icon → text spacing */
::v-deep(.v-list-item__prepend) {
  display: block !important;     /* overrides flex */
  min-width: unset !important;   /* removes reserved space */
  margin-inline-end: 0px;        /* control spacing */
  font-size: 20px;     /* try 14px – 16px */
  font-weight: 500;   /* optional: makes it cleaner */
  line-height: 1.4;
}

.v-list-item__content .sidebar-text{
  font-size: 16px;
}

/* Remove extra content padding */
::v-deep(.v-list-item__content) {
  padding-left: 0 !important;
}

/* Icon appearance */
.sidebar-icon {
  color: #64cf69 !important;
  opacity: 1 !important;
  font-size: 20px;
}

/* Text */
.sidebar-text {
  /* font-size: 5rem; */
  font-weight: 500;
  color: #1f2937;
  text-align: left;
  transition: opacity 0.2s ease;
}

/* Active item */
.router-link-active {
  background: rgba(100, 207, 105, 0.12);
}

.router-link-active .sidebar-text {
  color: #0f9d58;
  font-weight: 600;
  font-size: 16px;
}
</style>
